
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class OrderManagementCheckListGrid extends Serenity.EntityGrid<OrderManagementCheckListRow, any> {
        protected getColumnsKey() { return 'ECommerce.OrderManagementCheckList'; }
        protected getDialogType() { return OrderManagementCheckListDialog; }
        protected getIdProperty() { return OrderManagementCheckListRow.idProperty; }
        protected getInsertPermission() { return OrderManagementCheckListRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderManagementCheckListRow.localTextPrefix; }
        protected getService() { return OrderManagementCheckListService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}